import request from '@/utils/request'

export function listAdmin(query) {
  return request({
    url: '/list',
    method: 'get',
    params: query
  })
}

export function createAdmin(data) {
  return request({
    url: '/create',
    method: 'post',
    data
  })
}

export function readAdmin(data) {
  return request({
    url: '/read',
    method: 'get',
    data
  })
}

export function updateAdmin(data) {
  return request({
    url: '/update',
    method: 'post',
    data
  })
}

export function deleteAdmin(data) {
  return request({
    url: '/delete',
    method: 'post',
    data
  })
}
